module.exports = __webpack_public_path__ + "img/11087926_L.d90c92cb.png";